export const APK_DOWNLOAD_URL =
	'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.876_gw_07_14.apk'
